<template>
  <span v-if="isDisplay" v-cloak>
    <div class="d-flex align-center">
      <v-btn
        depressed
        small
        color="white"
        class="black--text font-weight-black mr-3"
        aling="left"
        @click="useGuideDownload()"
        >사용 가이드</v-btn
      >

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            depressed
            small
            color="amber lighten-1"
            class="black--text font-weight-black mr-4"
            aling="left"
            @click="chromeDownLoad()"
            v-bind="attrs"
            v-on="on"
            >크롬 다운로드</v-btn
          >
        </template>
        <span
          >멤버십 서비스는<br />
          안전한 크롬 브라우저에 최적화되어 있습니다.<br />
          크롬 브라우저로 사용하시길 권장합니다.</span
        >
      </v-tooltip>

      <template style="margin-top:10px;">
        <!--
        <v-btn icon @click="cafe24SiteShow()">
          <v-icon color="white">mdi-apps</v-icon>
        </v-btn>
        -->
        <div class="text-center">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon color="white">mdi-apps</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item
                class="hover"
                @click="cafe24SiteShow('https://store.cafe24.com/apps/10777')"
                style="text-decoration: none !important;"
              >
                <v-list-item-avatar tile size="80" color="grey"
                  ><img
                    src="https://cert-product.shoplus.store/authservice/etc/service_images/survey_icon.jpg"
                /></v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title
                    class="font-weight-bold body-1 black--text mb-0 d-block"
                  >
                    <p
                      class="mb-1 float-left align-center justify-center"
                      style="line-height: 1.8;"
                    >
                      맞춤 질문 추천 서비스
                    </p>
                    <p class="mb-1 float-right">
                      <v-icon>mdi-chevron-right</v-icon>
                    </p>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    고객 취향에 맞춘 개인화 상품 추천서비스.<br />
                    고객이 선택한 답변에 따라 상품을 추천하므로<br />
                    구매율과 만족도를 높여줍니다.<br />
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <!--
              <v-list-item
                class="hover"
                @click="cafe24SiteShow('https://store.cafe24.com/apps/8510')"
                style="text-decoration: none !important;"
              >
                <v-list-item-avatar tile size="80" color="grey"
                  ><img
                    src="https://cert-product.shoplus.store/authservice/etc/service_images/point_sales_service.jpg"
                /></v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title
                    class="font-weight-bold body-1 black--text mb-0 d-block"
                  >
                    <p
                      class="mb-1 float-left align-center justify-center"
                      style="line-height: 1.8;"
                    >
                      포인트 판매 서비스
                    </p>
                    <p class="mb-1 float-right">
                      <v-icon>mdi-chevron-right</v-icon>
                    </p>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    포인트를 판매하고 적립금을 자동 지급하는 서비스.<br />
                    회원들은 적립금 혜택으로 만족하고 남은 적립금은<br />
                    재방문/재구매를 이끌어줍니다.
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              -->
              <v-list-item
                class="hover"
                @click="cafe24SiteShow('https://store.cafe24.com/apps/4238')"
                style="text-decoration: none !important;"
              >
                <v-list-item-avatar tile size="80" color="grey"
                  ><img
                    src="https://cert-product.shoplus.store/authservice/etc/service_images/auth-code-service-icon.jpg"
                /></v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title
                    class="font-weight-bold body-1 black--text mb-0 d-block"
                  >
                    <p
                      class="mb-1 float-left align-center justify-center"
                      style="line-height: 1.8;"
                    >
                      정품 인증 서비스
                    </p>
                    <p class="mb-1 float-right">
                      <v-icon>mdi-chevron-right</v-icon>
                    </p>
                  </v-list-item-title>
                  <v-list-item-subtitle
                    >회원가입 및 브랜드 가치를 높여주는 서비스.<br />
                    정품 인증 회원에게 다양한 프로모션을 제공하고<br />
                    충성 고객으로 만들어보세요!</v-list-item-subtitle
                  >
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </template>
    </div>
  </span>
</template>
<style scoped>
[v-clock] {
  display: none;
}
.eAppVersion {
  color: white;
  text-decoration: none;
}
.eAppVersion:hover {
  text-decoration: underline;
}
.v-menu__content--fixed {
  margin-top: 20px;
  max-width: 450px;
}
.v-tooltip__content--fixed {
  margin-top: 20px;
}
</style>
<script>
export default {
  data: () => ({
    versionText: "D - day",
    isDisplay: false,
    menu: false,
  }),
  methods: {
    setExpiresDays: function(expiresDate) {
      if (expiresDate !== null) {
        let toDay = new Date();
        let expDate = expiresDate.substr(0, 10);
        let expParts = expDate.split("-");
        var endDate = new Date(expParts[0], expParts[1] - 1, expParts[2]);
        var gap = toDay.getTime() - endDate.getTime();
        var result = Math.floor(gap / (1000 * 60 * 60 * 24)) * -1;
        return ` (D-day ${result})`;
      }
    },
    movePayment: function() {
      this.$router.push({
        path: `/membership/${this.$store.state.mallId}/payment`,
      });
    },
    chromeDownLoad: function() {
      window.open("https://www.google.com/intl/ko/chrome/", "_blank");
    },
    cafe24SiteShow: function(v) {
      window.open(v, "_blank");
    },
    useGuideDownload: function() {
      window.open(
        "https://shoplustore.notion.site/shoplustore/GUIDE-7f48cb7a882e44309b04d090ce19ee09",
        "_blank"
      );
    },
  },
  mounted: function() {
    this.$nextTick(function() {
      setTimeout(() => {
        this.isDisplay = true;
      }, 500);
    });
  },
};
</script>
